import styled from 'styled-components'
import { Alert } from 'antd'

export const FormAlert = styled(Alert).attrs({ banner: true, showIcon: true })<{ $visible?: boolean }>`
  margin-bottom: 1rem;
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
`
